import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText,
  Stack,
  Touchable,
} from '../../../ui';

export type AboutIncentivesModalGotItCtaProps = {
  onDismiss: () => void;
};

export function AboutDiscountsModalGotItCta({
  onDismiss,
}: AboutIncentivesModalGotItCtaProps) {
  return (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
    >
      <Touchable
        onClick={onDismiss}
      >
        <Box
          minWidth={311}
          alignItems="center"
          color={colors.blackInBlack}
          borderRadius={4}
          paddingTop={12}
          paddingBottom={12}
        >
          <BodyText
            weight="bold"
            color={colors.whiteWash}
          >
            Got It
          </BodyText>
        </Box>
      </Touchable>
    </Stack>
  );
}
